<template>
  <div>
    <v-card  class="mx-auto" width="600">
      <v-card-title>
        <v-list-item-avatar color="grey darken-3">
          <v-img class="elevation-6" alt="" :src="post.member.avatar"></v-img>
        </v-list-item-avatar>
        <div>
          <span class="title font-weight-light">{{post.member.name}}</span>
          <div class="subtitle-2 grey--text" style="font-size: 12px!important;">{{formatDate(post.waktu)}}</div>
        </div>
        <v-row align="center" justify="end">
          <v-btn x-small fab text>
            <v-icon class="mr-4">
              more_vert
            </v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <div class="" style="white-space: initial;word-wrap: break-word;display:block;">
          <p v-html="post.msg"></p>
        </div>
      </v-card-text>
<!--      <v-divider/>-->
<!--      <v-card-actions>-->
<!--        <v-list-item class="grow">-->
<!--          <v-icon class="mr-1">-->
<!--            comment-->
<!--          </v-icon>-->
<!--          <v-row align="center" justify="end">-->
<!--            <v-icon class="mr-1">-->
<!--              mdi-heart-->
<!--            </v-icon>-->
<!--            <span class="subheading mr-2">256</span>-->
<!--            <span class="mr-1">·</span>-->
<!--            <v-icon class="mr-1">-->
<!--              mdi-share-variant-->
<!--            </v-icon>-->
<!--            <span class="subheading">45</span>-->
<!--          </v-row>-->
<!--        </v-list-item>-->
<!--      </v-card-actions>-->
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Post',
  props: ['post'],
  methods: {
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD HH:mm:ss')
    }
  }
}
</script>

<style scoped>

</style>
